<ng-container *transloco="let t; read: 'start'">
  <div class="p-d-flex p-flex-column p-jc-center p-ai-center" style="height: 100vh;">

    <div class="p-d-flex p-jc-center p-mt-4 p-mb-4" *ngIf="loading === true">
        <p-progressSpinner [style]="{width: '50px', height: '50px'}"></p-progressSpinner>
    </div>

    <p-card header="{{ t('title') }}" *ngIf="loading !== true" [ngClass]="{'full': mode === StartModes.Privacy}">

      <p-messages [(value)]="messages"></p-messages>

      <div *ngIf="mode === StartModes.Init">
        <p>{{ t('intro_init') }}</p>
        <button pButton type="button" (click)="onCodeGet()" label="{{ t('labels.request_now') }}" icon="pi pi-unlock" [disabled]="busy === true"></button>
        <p><a (click)="changeToCode()">{{ t('pin_code_available') }}</a></p>
      </div>

      <div *ngIf="mode === StartModes.Code">
        <p>{{ t('intro_code') }}</p>
        <form [formGroup]="codeForm" (ngSubmit)="onCodeSubmit()" class="p-mt-4">
          <span class="p-inputgroup p-mb-2">
            <span class="p-inputgroup-addon"><i class="pi pi-unlock"></i></span>
            <input type="text" pInputText formControlName="code" placeholder="{{ t('labels.pin_code') }}">
          </span>
          <button pButton type="submit" label="{{ t('labels.go_into_ac') }}" icon="pi pi-sign-in" class="p-mt-2" [disabled]="busy === true"></button>
        </form>
        <p><strong>{{ t('pin_code_not_received') }}</strong><br><a (click)="onCodeGet(true)">{{ t('pin_code_request') }}</a></p>
      </div>

      <div *ngIf="mode === StartModes.Privacy">
        <p><strong>{{ t('intro_privacy') }}</strong></p>
        <div [innerHtml]="ppPolicy?.[language.toUpperCase()] || ''"></div>
        <button pButton (click)="changeToCode()" type="button" label="{{ t('labels.cancel') }}" class="p-button-outlined p-mt-2 p-mr-2"></button>
        <button pButton (click)="onAcceptPrivacyPolicy()" type="button" label="{{ t('labels.accept') }}" icon="pi pi-user-edit" class="p-mt-2" [disabled]="busy === true"></button>
      </div>

    </p-card>

  </div>
</ng-container>
